<template>
    <div>
        <van-form ref="form" @submit="doLogin">
            <van-field
                v-model="form.phone"
                name="手机号"
                label="手机号"
                placeholder="请输入手机号"
                :rules="rules.phone"
            />

            <!-- 短信验证码 -->
            <sms-code :form="form"/>

            <div style="margin: 16px;">
                <van-button round block type="primary" native-type="submit"
                            :disabled="!enableSubmitBtn"
                >提交</van-button>
            </div>
        </van-form>
    </div>
</template>

<script>
import {doLoginBySmsCode} from "@/api/CommonApi";
import {Toast} from "vant";
import SmsCode from './sms-code';

export default {
    name: "login-phone",
    components:{SmsCode},
    data() {
        return {
            form: {
                phone: '',
                code: ''
            },
            hsPhone: false,
            hsCode: false,
            disableSmsSend:false,
            rules: {
                phone: [
                    { require:true, trigger: 'blur',message: '请输入手机号' },
                    { pattern:/^1[3456789]\d{9}$/, trigger: 'blur',message: '请输入正确的手机号码'}
                ],
                code: [
                    { require:true, trigger: 'blur',message: '请输入验证码' },
                ]
            },
        }
    },
    computed:{
        enableSubmitBtn(){
            return this.form.phone && this.form.code
        }
    },
    methods:{
        doLogin() {
            const data = {
                account:this.form.phone,
                smsCode:this.form.code,
                smsLogin:true,
            }
            doLoginBySmsCode(data).then((res) => {
                if(!res.success){
                    throw new Error(res.message)
                }
                localStorage.setItem('token',res.result)
                // 跳转到用户页
                this.$router.replace('/my')
            }).catch(err => {
                Toast.fail(err.message)
            })
        },
    }
}
</script>

<style scoped>

</style>
